import { render, staticRenderFns } from "./NoteDetailsActions.vue?vue&type=template&id=7c2286e6&scoped=true&"
import script from "./NoteDetailsActions.vue?vue&type=script&lang=js&"
export * from "./NoteDetailsActions.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetailsActions.vue?vue&type=style&index=0&id=7c2286e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2286e6",
  null
  
)

export default component.exports